import { Badge } from '@localagent/ui/components/badge';
import type { IntegrationAction } from '../../types/integrations-types';

const METHOD_COLORS: Record<string, string> = {
  GET: 'bg-chart-2/15 text-chart-2',
  POST: 'bg-chart-5/15 text-chart-5',
  PUT: 'bg-chart-3/15 text-chart-3',
  PATCH: 'bg-chart-6/15 text-chart-6',
  DELETE: 'bg-chart-4/15 text-chart-4',
};

export function ActionPreview({ actions }: { actions: IntegrationAction[] }) {
  if (actions.length === 0) {
    return <p className="text-body text-muted-foreground">No actions defined.</p>;
  }

  return (
    <div className="space-y-2">
      {actions.map((action) => (
        <div key={action.action_key} className="rounded bg-card p-3">
          <div className="flex items-center gap-2">
            <span className={`rounded px-1.5 py-0.5 text-caption font-mono font-medium ${METHOD_COLORS[action.http_method] || 'bg-muted'}`}>
              {action.http_method}
            </span>
            <span className="text-body font-mono text-muted-foreground">{action.path_template}</span>
            {action.pagination && <Badge variant="outline" className="text-caption">Paginated</Badge>}
            {action.response_transform && <Badge variant="outline" className="text-caption">Transformed</Badge>}
          </div>
          <div className="mt-1 text-label font-medium">{action.name}</div>
          {action.description && <p className="mt-0.5 text-caption text-muted-foreground">{action.description}</p>}
        </div>
      ))}
    </div>
  );
}
